<template>
  <div class="filter-page-title filter-page-options-desktop container mx-width">
    <div class="filter-title">
      <h2 v-if="primaryHeading" class="ctf-heading light filter-page-category">{{ primaryHeading }}</h2>
      <slot v-else-if="$slots.primaryHeading" name="primaryHeading"></slot>
      <div v-else></div>

      <div v-if="showFilters && SortOptions.length" class="filter-title-right">
        <div class="desktop-toggles">
          <select-input
            :modelValue="sort"
            @update:modelValue="$emit('update:sort', $event)"
            title="Sort by:"
            :options="SortOptions"
          ></select-input>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-page-options-mobile">
    <div class="filter-title container mx-width">
      <h2 class="ctf-heading filter-page-category">{{ primaryHeading }}</h2>
      <div v-if="showFilters" class="filter-title-right">
        <a class="navigation-drawer-open-button button uppercase small no-margin" @click.prevent="$emit('openFilterDrawer')"> 
          Filters
          <template v-if="filterCount">&nbsp;({{ filterCount }})</template> <i class="af af-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { Select } from '@/pixel/index';
import { SortOptions } from '@/components/commons/SortOptions.js';

export default {
  components: {
    'select-input': Select
  },

  props: {
    primaryHeading: {},
    showFilters: {},
    sort: {},
    filterCount: {}
  },

  emits: ['update:sort', 'openFilterDrawer'],

  setup() {
    return {
      SortOptions
    };
  }
}
</script>
<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.filter-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.filter-title-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  .desktop-toggles {
    display: flex;
  }

  @media (max-width: calc($tablet-breakpoint - 1px)) {
    .desktop-toggles {
      display: none;
    }
  }

  .select,
  .toggle {
    margin-left: 25px;
    font-size: var(--font-size-14);
  }
}

.navigation-drawer-open-button {
  display: flex;

  @media (min-width: $tablet-breakpoint) {
    display: none;
  }

  .af {
    margin-left: 5px;
    font-size: var(--font-size-14);
  }
}

.filter-page-parent-category-mobile {
  font-size: 1.2em;
}

@media (min-width: $tablet-breakpoint) {
  .filter-page-parent-category-mobile {
    display: none;
  }
}

.filter-page-options-mobile {
  position: sticky;
  top: 0;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 10;

  .filter-title {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  h1 {
    font-size: 1.3em;
    line-height: 1.25em;
  }
}

@media (min-width: $tablet-breakpoint) {
  .filter-page-options-mobile {
    display: none;
  }
}

@media (max-width: calc($tablet-breakpoint - 1px)) {
  .filter-page-options-desktop {
    display: none;
  }

  &.mobile-disable-margin-top {
    margin-top: 0px;
  }
}

.filter-page-parent-category {
  margin-bottom: 10px;
}

@media (min-width: $tablet-breakpoint) {
  .filter-page-parent-category {
    display: none;
  }
}

@media (max-width: calc($tablet-breakpoint - 1px)) {
  .filter-page-category {
    margin-right: 5px;
  }
}
</style>